import { zodResolver } from '@hookform/resolvers/zod'
import { useCallback, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import z from 'zod'

export interface EmailPasswordFormType {
  password: string
  passwordConfirm: string
}

const useEmailPasswordForm = () => {
  const defaultValues = useCallback((): EmailPasswordFormType => ({
    password: '',
    passwordConfirm: '',
  }), [])

  const validationSchema = useMemo(() => z.object({
    password: z.string()
      .min(8, 'Password must be at least 8 characters')
      .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
      .regex(/[0-9]/, 'Password must contain at least one number'),
    passwordConfirm: z.string(),
  }).superRefine((data, ctx) => {
    if (data.password && data.passwordConfirm !== data.password) {
      ctx.addIssue({
        code: 'custom',
        message: 'Passwords do not match',
        path: ['passwordConfirm'],
      })
    }
  }), [])

  const form = useForm<EmailPasswordFormType>({
    defaultValues: defaultValues(),
    resolver: zodResolver(validationSchema),
  })

  const resetForm = useCallback(() => {
    form.reset(defaultValues())
  }, [form, defaultValues])

  return {
    form,
    resetForm,
  }
}

export default useEmailPasswordForm
